import type { ZudokuConfig } from "zudoku";
import { navigation } from "./navigation";
import { redirects } from "./redirects";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "zudoku/ui/Tabs";
import { ScrollArea, ScrollBar } from "zudoku/ui/ScrollArea";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "zudoku/ui/Card";
import { Button } from "zudoku/ui/Button";
import { Popover, PopoverContent, PopoverTrigger, } from "zudoku/ui/Popover";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious, } from "zudoku/ui/Carousel";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger, } from "zudoku/ui/Accordion";
import { StandardIntegration } from "./src/standard-integration";
import { unoChatPlugin } from "./src/uno-chat-plugin";
import { mindboxTrackerPlugin } from "./src/mindbox-tracker-plugin";
import { Link } from "zudoku/components";
import { CircleAlertIcon, OctagonXIcon } from "zudoku/icons";
import { Callout } from "zudoku/ui/Callout";
import { Mermaid } from "zudoku/mermaid";

const config: ZudokuConfig = {
  plugins: [unoChatPlugin(), mindboxTrackerPlugin()],
  metadata: {
    favicon: "/mb-help-fav_Product_Help.svg",
    title: "",
  },
  site: {
    title: "Mindbox",
    logo: {
      src: { light: "/mindbox-black.svg", dark: "/mindbox-white.svg" },
      alt: "Mindbox",
      width: "130px",
    },
  },
   docs: {
    defaultOptions: {
      copyPage: true,
      showLastModified: true,
    },
    publishMarkdown: true,
    llms: { llmsTxt: true, llmsTxtFull: true },
  },
  navigation,
  syntaxHighlighting: {
    themes: {
      light: "vitesse-light",
      dark: "vitesse-dark",
    },
    languages: ["csv", "swift", "kotlin", "dart", "html", "javascript", "json", "xml", "php", "typescript","objective-c", "groovy", "java", "yaml", "ruby", "sql", "python", "coffee" ],
  },
  mdx: {
    components: {
      Tabs,
      TabsContent,
      TabsList,
      TabsTrigger,
      ScrollArea,
      ScrollBar,
      Card,
      CardContent,
      CardDescription,
      CardFooter,
      CardHeader,
      CardTitle,
      Button,
      Popover,
      PopoverContent,
      PopoverTrigger,
      Carousel,
      CarouselContent,
      CarouselItem,
      CarouselNext,
      CarouselPrevious,
      Accordion,
      AccordionContent,
      AccordionItem,
      AccordionTrigger,
      StandardIntegration,
      Link,
      CircleAlertIcon,
      OctagonXIcon,
      Callout,
      Mermaid,
    },
  },
  redirects,
  "theme": {
    "light": {
      "background": "oklch(100% 0 none)",
      "foreground": "oklch(14.1% 0.004 286)",
      "card": "oklch(100% 0 none)",
      "cardForeground": "oklch(14.1% 0.004 286)",
      "popover": "oklch(100% 0 none)",
      "popoverForeground": "oklch(14.1% 0.004 286)",
      "primary": "oklch(62.7% 0.17 149)",
      "primaryForeground": "oklch(97% 0.015 12.4)",
      "secondary": "oklch(96.8% 0.001 286)",
      "secondaryForeground": "oklch(21% 0.006 286)",
      "muted": "oklch(96.8% 0.001 286)",
      "mutedForeground": "oklch(55.2% 0.014 286)",
      "accent": "oklch(96.8% 0.001 286)",
      "accentForeground": "oklch(21% 0.006 286)",
      "destructive": "oklch(63.7% 0.208 25.3)",
      "destructiveForeground": "oklch(98.5% 0 none)",
      "border": "oklch(92% 0.004 286)",
      "input": "oklch(92% 0.004 286)",
      "ring": "oklch(62.7% 0.17 149)"
    },
    "dark": {
      "background": "oklch(14.7% 0.004 49.3)",
      "foreground": "oklch(96.2% 0 none)",
      "popover": "oklch(20.4% 0 none)",
      "popoverForeground": "oklch(96.2% 0 none)",
      "card": "oklch(21.6% 0.006 56)",
      "cardForeground": "oklch(96.2% 0 none)",
      "primary": "oklch(72.3% 0.192 150)",
      "primaryForeground": "oklch(26.6% 0.063 153)",
      "secondary": "oklch(27.4% 0.005 286)",
      "secondaryForeground": "oklch(98.5% 0 none)",
      "muted": "oklch(27% 0 none)",
      "mutedForeground": "oklch(71.2% 0.013 286)",
      "accent": "oklch(26.9% 0.006 34.3)",
      "accentForeground": "oklch(98.5% 0 none)",
      "destructive": "oklch(39.6% 0.133 25.7)",
      "destructiveForeground": "oklch(97.1% 0.013 17.4)",
      "border": "oklch(27.4% 0.005 286)",
      "input": "oklch(27.4% 0.005 286)",
      "ring": "oklch(52.7% 0.137 150)"
    }
  },
  search: {
    type: "pagefind",
    // Optional: Maximum number of sub results per page
    maxSubResults: 4,
    // Optional: Configure search result ranking (defaults shown below)
    ranking: {
      termFrequency: 1.0,
      pageLength: 0.0,
      termSimilarity: 0.2,
      termSaturation: 1.6,
    },
  },
  "sitemap": {
    "siteUrl": "https://developers.mindbox.ru",
    "changefreq": "daily",
    "priority": 0.7,
    "autoLastmod": true,
  },
};

export default config;
